<template>
  <div>
    <b-overlay :show="loading" opacity="0.99">
      <div class="col-md-12 pt-0 pb-0 text-center m-1">
        <v-btn class="btn-edit m-2" @click="handleTypeEdit('INSTRUCTION')">
          <i class="fas fa-edit mr-2 text-twenty"></i>EDITAR INSTRUÇÃO
        </v-btn>

        <v-btn class="v-warning m-2" @click="handleTypeEdit('CARE')">
          <i class="fas fa-hand-holding-heart mr-2 text-twenty"></i>
          EDITAR CUIDADO
        </v-btn>

        <ErrorsMessages :errors="errors" />
        <div v-if="datesCheck && datesCheck.length > 0" class="border">
          <h6 class="title-pages text-fifteen text-center border-bottom">
            DATA(S) QUE O CUIDADO ESTÁ APENAS SEPARADO
          </h6>
          <div v-for="(date, key) in datesCheck" :key="key">
            <div class="d-flex align-items-center justify-content-center">
              <b class="mr-2">{{ formatDate(date, false) }}</b>
              <v-btn
                small
                @click="handleCheckDate(date)"
                class="mt-1 mb-1 v-primary"
              >
                <i class="fas fa-arrow-right mr-2"></i>
                ACESSAR
              </v-btn>
            </div>
          </div>
        </div>
      </div>

      <div v-show="edit == 'INSTRUCTION'">
        <div class="row">
          <div class="col-md-12">
            <h6 class="text-fourteen">INSTRUÇÃO</h6>
            <ChromeSpeechToTextTextarea
              rows="4"
              max-rows="10"
              v-model="instruction"
            />
          </div>
          <div class="col-md-12">
            <ErrorsMessages :errors="errors" />
          </div>
          <div class="col-md-12 text-right">
            <v-btn
              :disabled="loadingUpdate"
              @click="updateInstruction"
              class="btn-acess"
            >
              {{ loadingUpdate ? "CARREGANDO" : "SALVAR INSTRUÇÃO" }}
            </v-btn>
          </div>
        </div>
      </div>

      <div v-show="edit == 'CARE'">
        <div v-show="step == 1">
          <div class="row">
            <div
              class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 d-flex justify-content-center"
            >
              <i class="fas fa-hand-holding-heart fa-3x color-blue"></i>
            </div>

            <div class="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-12 pt-1">
              <h6 class="mb-0 check-text-center">CUIDADO: {{ name }}</h6>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
              <label>FREQUÊNCIA</label>

              <select
                @change="handleChangeFrequency($event.target.value)"
                v-model="frequency"
                class="form-control"
              >
                <option value="DIARIO">DIÁRIO</option>

                <option value="SEMANAL">SEMANAL</option>

                <option
                  v-if="group_prescription_care.type == 'NORMAL'"
                  value="EVENTUAL"
                >
                  EVENTUAL
                </option>
              </select>
            </div>

            <div
              v-if="show_all_frequency"
              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
            >
              <label>QUANTIDADE DIÁRIA</label>

              <select
                @change="handleChangeCareAmountOfTimesId($event.target.value)"
                v-model="care_amount_of_times_id"
                class="form-control"
              >
                <option value>SELECIONE...</option>

                <option
                  v-for="value in amountOfTimes"
                  :key="value.id"
                  :value="value.id"
                  :ref="`care_amount_of_times_${value.id}`"
                  :data-type="value.type"
                >
                  {{ value.name }}
                </option>
              </select>
            </div>

            <div
              v-if="show_all_frequency"
              class="col-md-12 d-flex align-items-center"
            >
              <label class="mb-0 day-width">A CADA</label>

              <input v-model="every" type="text" class="form-control" />

              <label class="mb-0 day-width pl-3"
                >{{ care_frequency_abbreviation }}(S)</label
              >
            </div>

            <div v-if="show_weekly" class="p-2 col-md-12 text-center">
              <v-btn
                :class="['v-no-border-radius', DOM ? 'v-primary' : '']"
                @click="DOM = !DOM"
                >DOM</v-btn
              >

              <v-btn
                :class="['v-no-border-radius', SEG ? 'v-primary' : '']"
                @click="SEG = !SEG"
                >SEG</v-btn
              >

              <v-btn
                :class="['v-no-border-radius', TER ? 'v-primary' : '']"
                @click="TER = !TER"
                >TER</v-btn
              >

              <v-btn
                :class="['v-no-border-radius', QUA ? 'v-primary' : '']"
                @click="QUA = !QUA"
                >QUA</v-btn
              >

              <v-btn
                :class="['v-no-border-radius', QUI ? 'v-primary' : '']"
                @click="QUI = !QUI"
                >QUI</v-btn
              >

              <v-btn
                :class="['v-no-border-radius', SEX ? 'v-primary' : '']"
                @click="SEX = !SEX"
                >SEX</v-btn
              >
              <v-btn
                :class="['v-no-border-radius', SAB ? 'v-primary' : '']"
                @click="SAB = !SAB"
                >SAB</v-btn
              >
            </div>

            <div class="col-md-12" v-if="show_shifts">
              <div>
                <vs-checkbox v-model="dawn">MADRUGADA</vs-checkbox>
              </div>
              <hr />
              <div>
                <vs-checkbox v-model="morning">MANHÃ</vs-checkbox>
              </div>
              <hr />
              <div>
                <vs-checkbox v-model="afternoon">TARDE</vs-checkbox>
              </div>
              <hr />
              <div>
                <vs-checkbox v-model="night">NOITE</vs-checkbox>
              </div>
              <hr />
              <div>
                <vs-checkbox v-model="shift_5">5º</vs-checkbox>
              </div>
              <hr />
              <div>
                <vs-checkbox v-model="shift_6">6º</vs-checkbox>
              </div>
              <hr />
              <div>
                <vs-checkbox v-model="shift_7">7º</vs-checkbox>
              </div>
              <hr />
              <div>
                <vs-checkbox v-model="shift_8">8º</vs-checkbox>
              </div>
            </div>

            <div class="col-md-12">
              <ErrorsMessages :errors="errors" />
            </div>
          </div>
        </div>

        <div v-show="step == 2">
          <div class="row">
            <div v-if="!show_instruction" class="col-md-12">
              <h6 class="text-fourteen">DURAÇÃO</h6>
              <vs-radio
                @change="handleChangeDuration($event.target.value)"
                v-model="duration"
                vs-value="CONTINUO"
                >CONTÍNUO</vs-radio
              >
              <vs-radio
                @change="handleChangeDuration($event.target.value)"
                v-if="show_during_a_period"
                v-model="duration"
                vs-value="DURANTE_UM_PERIODO"
                >DURANTE UM PERÍODO</vs-radio
              >
              <vs-radio
                @change="handleChangeDuration($event.target.value)"
                v-model="duration"
                vs-value="ATE_A_DATA"
                >ATÉ A DATA</vs-radio
              >
              <div
                class="col-md-12"
                v-if="
                  (!show_instruction && show_start_date) ||
                  (!show_instruction && show_end_date) ||
                  (!show_instruction && show_duration_time)
                "
              >
                <div v-if="duration != 'CONTINUO'" class="row v-clean">
                  <div
                    v-if="!show_instruction && show_start_date"
                    class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-2"
                  >
                    <h6 class="text-fourteen">DATA DE INÍCIO</h6>
                    <input
                      v-model="start_date"
                      type="date"
                      class="form-control"
                    />
                  </div>
                  <div
                    v-if="!show_instruction && show_end_date"
                    class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-2"
                  >
                    <h6 class="text-fourteen">DATA DE TÉRMINO</h6>
                    <input
                      v-model="end_date"
                      type="date"
                      class="form-control"
                    />
                  </div>
                  <div
                    v-if="!show_instruction && show_duration_time"
                    class="col-xl-6 col-lg-6 col-md-6 col-sm-9 col-12 pl-5 pt-3"
                  >
                    <h6 class="text-fourteen">TEMPO DE DURAÇÃO</h6>
                    <vs-slider :min="1" :max="30" v-model="duration_time" />
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <h6 class="c-primary">{{ duration_time }} DIA(S)</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="duration == 'CONTINUO'"
              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 mb-2 pt-0 pl-3"
            >
              <h6 class="text-fourteen">INICIAR CUIDADO</h6>
              <input v-model="init" type="date" class="form-control" />
            </div>
            <div class="col-md-12 pt-0 pl-3">
              <h6 class="text-fourteen">INSTRUÇÃO</h6>
              <ChromeSpeechToTextTextarea
                rows="4"
                max-rows="10"
                v-model="instruction"
              />
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <ErrorsMessages :errors="errors" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 d-flex justify-content-between">
            <v-btn
              :disabled="step == 1"
              @click="handlePrevStep"
              class="btn-return"
            >
              <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
            </v-btn>
            <v-btn
              v-if="step != 2"
              :disabled="loadingUpdate"
              @click="handleNextStep"
              class="btn-acess"
            >
              AVANÇAR
            </v-btn>
            <v-btn
              v-if="step == 2"
              :disabled="loadingUpdate"
              @click="handleNextStep"
              :class="[
                group_prescription_care.status == 'PENDENTE'
                  ? 'btn-modern btn-modern-save'
                  : 'btn-notcertified',
              ]"
            >
              <span v-if="loading">CARREGANDO</span>
              <span v-if="!loading">SALVAR</span>
            </v-btn>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../../templates/Components/ErrorsMessages";

import ChromeSpeechToTextTextarea from "../../../templates/Components/ChromeSpeechToTextTextarea";

import api from "../../../services/api";

import { userData } from "../../../lib/functions";

import toast from "../../../lib/ToastNotification";

import { formatDateToUs, formatDate } from "../../../lib/format";

export default {
  name: "CareViewEdit",

  components: {
    ErrorsMessages,
    ChromeSpeechToTextTextarea,
  },

  data() {
    return {
      step: 1,

      edit: "",

      care: null,

      care_type: null,

      id: "",

      user_id: "",

      resident_id: "",

      rest_home_id: "",

      unit_of_measurement_id: "",

      route_of_administration_id: "",

      name: "",

      unit_of_measurement_name: "",

      unit_of_measurement_value: "",

      unit_of_measurement_abbreviation: "",

      care_amount_of_times_id: "",

      unitOfMeasurements: [],

      routeOfAdministration: [],

      careAmountOfTimes: [],

      amountOfTimes: [],

      care_frequency_abbreviation: "DIA",

      errors: [],

      loading: false,

      loadingUpdate: false,

      show_all_frequency: true,

      show_weekly: false,

      type_care_amount_of_times_id: "",

      show_shifts: false,

      frequency: "DIARIO",

      every: "",

      morning: false,

      afternoon: false,

      night: false,

      dawn: false,

      shift_5: false,

      shift_6: false,

      shift_7: false,

      shift_8: false,

      DOM: false,

      SEG: false,

      TER: false,

      QUA: false,

      QUI: false,

      SEX: false,

      SAB: false,

      duration: "CONTINUO",

      show_during_a_period: false,

      instruction: "",

      show_instruction: false,

      start_date: "",

      show_start_date: false,

      end_date: "",

      show_end_date: false,

      duration_time: 1,

      show_duration_time: false,

      repeat_after_type: "MES",

      repeat_dosage: 0,

      repeat_after: "NAO",

      how_many_times: 1,

      init: "",

      datesCheck: [],
    };
  },

  props: {
    prescription_care: { type: Object },
    group_prescription_care: { type: Object },
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDateToUs,
    formatDate,

    handleTypeEdit(edit) {
      this.edit = "";

      this.errors = [];

      if (edit == "CARE") {
        this.isValidToUpdate();
      } else {
        this.edit = edit;
      }
    },

    handlePrevStep() {
      const { step, group_prescription_care, frequency } = this;

      let SEMANAL = "SEMANAL";

      if (step == 1) {
        return;
      }

      if (group_prescription_care.type == "NORMAL") {
        this.step = step - 1;
      } else {
        if (step == 2) {
          if (frequency == SEMANAL) {
            this.step = step - 1;
          }
        } else {
          this.step = step - 1;
        }
      }
    },

    handleNextStep() {
      this.errors = [];

      let { step, group_prescription_care } = this;

      if (step == 1) {
        let {
          frequency,
          care_amount_of_times_id,
          care_frequency_abbreviation,
          every,
          DOM,
          SEG,
          TER,
          QUA,
          QUI,
          SEX,
          SAB,
          morning,
          afternoon,
          night,
          dawn,
          shift_5,
          shift_6,
          shift_7,
          shift_8,
          type_care_amount_of_times_id,
        } = this;

        let DIARIO = "DIARIO";
        let SEMANAL = "SEMANAL";
        let EVENTUAL = "EVENTUAL";

        if (!String(frequency).trim()) {
          this.errors.push({
            id: this.errors.length,
            message: "Informe frequência",
          });
        }

        if (!String(care_amount_of_times_id).trim()) {
          this.errors.push({
            id: this.errors.length,
            message: "Informe quantidade diária",
          });
        }

        if (frequency != EVENTUAL) {
          if (frequency == SEMANAL) {
            if (!DOM && !SEG && !TER && !QUA && !QUI && !SEX && !SAB) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe ao menos um dia da semana",
              });
            }

            if (Number(every) < 1 || !Number(every)) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe o intervalo",
              });
            }
          }

          if (type_care_amount_of_times_id == "SHIFTS") {
            if (
              !morning &&
              !afternoon &&
              !night &&
              !dawn &&
              !shift_5 &&
              !shift_6 &&
              !shift_7 &&
              !shift_8
            ) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe ao menos um turno",
              });
            }
          }

          if (type_care_amount_of_times_id == "DAY") {
            if (!String(every).trim()) {
              this.errors.push({
                id: this.errors.length,
                message: `Informe a cada ${care_frequency_abbreviation}`,
              });
            }
          }
        }

        if (this.errors.length > 0) {
          return;
        }

        if (frequency == EVENTUAL) {
          this.show_instruction = true;
        } else {
          this.show_instruction = false;
        }

        if (frequency == DIARIO) {
          this.show_during_a_period = true;
        } else {
          this.show_during_a_period = false;
        }

        if (group_prescription_care.type == "NORMAL") {
          this.step = step + 1;
        } else {
          if (frequency == SEMANAL) {
            this.step = step + 1;
          } else {
            this.step = 2.5;
          }
        }
        // this.step = step + 1;
      }

      if (step == 2) {
        let {
          frequency,
          duration,
          instruction,
          start_date,
          end_date,
          duration_time,
          init,
        } = this;

        // let DIARIO = "DIARIO";
        // let SEMANAL = "SEMANAL";
        // let MENSAL = "MENSAL";
        // let ANUAL = "ANUAL";
        let EVENTUAL = "EVENTUAL";

        const ATE_A_DATA = "ATE_A_DATA";
        const DURANTE_UM_PERIODO = "DURANTE_UM_PERIODO";

        if (duration == ATE_A_DATA) {
          if (frequency != EVENTUAL) {
            if (!String(start_date).trim()) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe a data de início",
              });
            }
          }

          if (!String(end_date).trim()) {
            this.errors.push({
              id: this.errors.length,
              message: "Informe data de término",
            });
          }
        }

        if (duration == DURANTE_UM_PERIODO) {
          if (frequency != EVENTUAL) {
            if (!String(start_date).trim()) {
              this.errors.push({
                id: this.errors.length,
                message: "Informe a data de início",
              });
            }
          }

          if (!String(duration_time).trim()) {
            this.errors.push({
              id: this.errors.length,
              message: "Informe tempo de duração",
            });
          }
        }

        if (frequency == EVENTUAL) {
          if (!String(instruction).trim()) {
            this.errors.push({
              id: this.errors.length,
              message: "Informe instrução",
            });
          }
        }

        if (!init && duration == "CONTINUO") {
          this.errors.push({
            id: this.errors.length,
            message: "Informe a data que o Cuidado irá iniciar",
          });
        }

        if (this.errors.length > 0) {
          return;
        }

        this.update();
      }
    },

    handleChangeCareAmountOfTimesId(value) {
      this.show_shifts = false;

      this.care_amount_of_times_abbreviation = "";

      const SHIFTS = "SHIFTS";

      if (value) {
        let { type } = this.$refs[`care_amount_of_times_${value}`][0].dataset;

        this.type_care_amount_of_times_id = type;

        if (type == SHIFTS) {
          this.show_shifts = true;
        }
      }
    },

    handleChangeFrequency(value) {
      const { careAmountOfTimes } = this;

      this.show_all_frequency = true;

      this.show_weekly = false;

      this.show_duration_time = false;

      this.duration = "CONTINUO";

      this.amountOfTimes = careAmountOfTimes;

      this.DOM = false;

      this.SEG = false;

      this.TER = false;

      this.QUA = false;

      this.QUI = false;

      this.SEX = false;

      this.SAB = false;

      let care_frequency_abbreviation = {
        DIARIO: "DIA",
        SEMANAL: "SEMANA",
        MENSAL: "MÊS",
        ANUAL: "ANO",
      };

      const SEMANAL = "SEMANAL";

      const EVENTUAL = "EVENTUAL";

      if (value == EVENTUAL) {
        this.show_all_frequency = false;

        this.care_amount_of_times_id = 1;

        this.type_care_amount_of_times_id = "DAY";

        this.show_shifts = false;

        let amountOfTimes = [];

        for (let item of careAmountOfTimes) {
          if (item.type == "DAY") {
            amountOfTimes.push(item);
          }
        }

        this.amountOfTimes = amountOfTimes;
      }

      if (value == SEMANAL) {
        this.show_weekly = true;
      }

      this.care_frequency_abbreviation = care_frequency_abbreviation[value];
    },

    handleChangeDuration(value) {
      const CONTINUO = "CONTINUO";
      const ATE_A_DATA = "ATE_A_DATA";
      const DURANTE_UM_PERIODO = "DURANTE_UM_PERIODO";

      if (value == CONTINUO) {
        this.show_start_date = false;
      } else {
        this.show_start_date = true;
      }

      if (value == ATE_A_DATA) {
        this.show_end_date = true;
      } else {
        this.show_end_date = false;
      }

      if (value == DURANTE_UM_PERIODO) {
        this.show_duration_time = true;
      } else {
        this.show_duration_time = false;
      }
    },

    async retrieve() {
      this.loading = true;

      let { user } = userData();

      this.rest_home_id = user.rest_home_id;
      this.user_id = user.id;

      const { prescription_care } = this;

      this.resident_id = prescription_care.resident_id;

      if (this.errors.length == 0) await this.getUnitOfMeasurements();
      if (this.errors.length == 0) await this.getRouteOfAdministration();
      if (this.errors.length == 0) await this.getCareAmountOfTimes();
      if (this.errors.length > 0) return;

      let {
        id,
        care_name,
        unit_of_measurement_id,
        unit_of_measurement_name,
        unit_of_measurement_abbreviation,
        unit_of_measurement_value,
        route_of_administration_id,
        frequency,
        care_amount_of_times_id,
        every,
        morning,
        afternoon,

        night,

        dawn,

        shift_5,

        shift_6,

        shift_7,

        shift_8,

        dom,
        seg,
        ter,
        qua,
        qui,
        sex,
        sab,

        start_date,
        duration,
        duration_time,
        end_date,
        instruction,
        repeat_after_type,
        repeat_dosage,
        repeat_after,
        how_many_times,
      } = prescription_care;

      this.handleChangeFrequency(frequency);
      this.handleChangeCareAmountOfTimesId(care_amount_of_times_id);
      this.handleChangeDuration(duration);

      this.id = id;
      this.name = care_name;
      this.unit_of_measurement_id = unit_of_measurement_id;
      this.unit_of_measurement_value = unit_of_measurement_value;
      this.unit_of_measurement_name = unit_of_measurement_name;
      this.unit_of_measurement_abbreviation = unit_of_measurement_abbreviation;
      this.route_of_administration_id = route_of_administration_id;
      this.frequency = frequency;
      this.care_amount_of_times_id = care_amount_of_times_id;
      this.morning = morning;

      this.afternoon = afternoon;

      this.night = night;

      this.dawn = dawn;

      this.shift_5 = shift_5;

      this.shift_6 = shift_6;

      this.shift_7 = shift_7;

      this.shift_8 = shift_8;

      this.every = every;
      this.DOM = dom;
      this.SEG = seg;
      this.TER = ter;
      this.QUA = qua;
      this.QUI = qui;
      this.SEX = sex;
      this.SAB = sab;

      this.start_date = formatDateToUs(start_date);
      this.duration = duration;
      this.duration_time = duration_time;
      this.end_date = formatDateToUs(end_date);
      this.instruction = instruction;
      this.repeat_after_type = repeat_after_type;
      this.repeat_dosage = repeat_dosage;
      this.repeat_after = repeat_after;
      this.how_many_times = how_many_times;

      this.loading = false;
    },

    async getUnitOfMeasurements() {
      try {
        const response = await api.get("/rest-home/unit-of-measurement/all");

        const { error, errors, unit_of_measurement } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.unitOfMeasurements = unit_of_measurement;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getRouteOfAdministration() {
      try {
        const response = await api.get("/admin/care/routes-of-administration");

        const { error, errors, routes_of_administration } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.routeOfAdministration = routes_of_administration;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getCareAmountOfTimes() {
      try {
        const response = await api.get("/admin/medicine-amount-of-times");

        const { error, errors, medicine_amount_of_times } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];

          this.careAmountOfTimes = medicine_amount_of_times;

          this.amountOfTimes = medicine_amount_of_times;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async update() {
      try {
        this.loadingUpdate = true;

        let {
          id,
          rest_home_id,
          user_id,
          resident_id,
          unit_of_measurement_id, //VALOR UNIDADE DE MEDIDA
          unit_of_measurement_value, //VALOR UNIDADE DE MEDIDA
          route_of_administration_id, //VIA DE ADMINISTRAÇÃO
          frequency, //FREQUÊNCIA
          care_amount_of_times_id, //QUANTIDADE DIÁRIA
          type_care_amount_of_times_id, //TIPO QUANTIDADE DIÁRIA
          every, //A CADA,
          DOM,
          SEG,
          TER,
          QUA,
          QUI,
          SEX,
          SAB,
          morning, //MANHÃ
          afternoon, //TARDE
          night, //NOITE
          dawn, //MADRUGADA
          shift_5, //5º
          shift_6, //6º
          shift_7, //7º
          shift_8, //8º
          start_date, //DATA DE INÍCIO
          duration, //DURAÇÃO
          duration_time, //TEMPO DE DURAÇÃO
          end_date, //DATA DE TÉRMINO
          instruction, //INSTRUÇÃO

          repeat_after_type,
          repeat_dosage,
          repeat_after,
          how_many_times,
          init,
        } = this;

        let params = {
          id,
          rest_home_id,
          user_id,
          resident_id,
          unit_of_measurement_id,
          unit_of_measurement_value,
          route_of_administration_id,
          frequency,
          care_amount_of_times_id,
          type_care_amount_of_times_id,
          every,
          DOM,
          SEG,
          TER,
          QUA,
          QUI,
          SEX,
          SAB,
          morning,
          afternoon,
          night,
          dawn,
          shift_5,
          shift_6,
          shift_7,
          shift_8,
          start_date,
          duration,
          duration_time,
          end_date,
          instruction,

          repeat_after_type,
          repeat_dosage,
          repeat_after,
          how_many_times,
          init,
        };

        const response = await api.put("/rest-home/prescription-care", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("update", "paginate");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async updateInstruction() {
      try {
        this.loadingUpdate = true;

        let { id, instruction } = this;

        let params = { id, instruction };

        const response = await api.put(
          "/rest-home/prescription-care-instruction",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("update", "paginate");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    async isValidToUpdate() {
      try {
        this.loadingUpdate = true;

        let { id, resident_id } = this;

        let params = { id, resident_id };

        const response = await api.get("/rest-home/prescription-care", {
          params,
        });

        const { error, errors, dates } = response.data;

        if (!error) {
          this.errors = [];
          this.datesCheck = [];
          this.edit = "CARE";
        } else {
          this.errors = errors;
          this.datesCheck = dates;
        }

        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleCheckDate(date) {
      let route = this.$router.resolve({
        name: "resident",
        query: { tab: "check", nav: "check", date },
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>
